import * as Yup from 'yup';
import { OVM } from '../../models';

export function useValidationSchema() {
  return Yup.object<OVM>().shape({
    ico: Yup.string().nullable().required('Povinné pole'),
  });
}
